import React, { useState, useEffect } from "react";
import {
  Card,
  Box,
  InputBase,
  Stack,
  CardContent,
  Tooltip,
  IconButton,
  CircularProgress,
  useMediaQuery,
  Modal,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  AppBar,
  TableCell,
} from "@mui/material";
import Navbar from "../../../Navbar";
import Footer from "../../../Footer";
import Header from "../../../Header";
import EnqDetails from "./EnqDetails";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import Followup from "./ActionComponent/Followup";
import CircleIcon from "@mui/icons-material/Circle";
import SearchIcon from "@mui/icons-material/Search";
import LanguageIcon from "@mui/icons-material/Language";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DirectionsWalkOutlinedIcon from "@mui/icons-material/DirectionsWalkOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { API_URL } from "../../Config/api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  pt: 2,
  px: 4,
  pb: 3,
  backgroundColor: "#f1f1f1",
};

const EnquiryCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "#f1f1f1",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "54px",
  borderRadius: "10px",
  transition: "2s ease-in-out",
  "&:hover": {
    // backgroundColor: "rgb(207, 207, 207)",
    // cursor: 'pointer',
  },
});

const Enquiries = () => {
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");
  const accessHospitalID = localStorage.getItem("hospitalID") || 0;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [enq, setEnq] = useState([]);
  const [enqID, setEnqID] = useState([]);
  const [preFollowup, setPreFollowup] = useState([]);

  const [tableHeight, setTableHeight] = useState("auto");
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [selectedCallerStatus, setSelectedCallerStatus] = useState("");

  const [loading, setLoading] = useState(true);

  const flag = 1;

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
    setPage(0);
  };

  const handleServiceChange = (e) => {
    setSelectedService(e.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //Code for Model
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const updateTableHeight = () => {
      const screenHeight = window.innerHeight;
      setTableHeight(`${screenHeight}px`);
    };
    updateTableHeight();
    window.addEventListener("resize", updateTableHeight);

    return () => {
      window.removeEventListener("resize", updateTableHeight);
    };
  }, []);

  useEffect(() => {
    const getEnquires = async () => {
      // if (accessHospitalID) {
      try {
        const res = await fetch(
          `${API_URL}/web/Follow_Up_combined_table/${accessHospitalID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        console.log("Enquiries Data.........", data);
        if (data.detail === "No matching records found") {
          setEnq([]);
          setLoading(false);
        } else {
          setEnq(data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching Enquiries Data:", error);
        setLoading(false);
      }
      // }
    };
    getEnquires();
  }, [accessHospitalID]);

  function findPreFollowupRecords(eveId) {
    console.log(eveId, ".................");

    const matchingRecords = enq.find((record) => record.eve_id === eveId);
    if (matchingRecords) {
      console.log("Previos Followup ID", matchingRecords.eve_id);
      setEnqID(matchingRecords.eve_id);
    }
  }

  useEffect(() => {
    const getPreFollowup = async () => {
      if (enqID) {
        console.log("Event ID.....", enqID);
        try {
          const res = await fetch(`${API_URL}/web/previous_follow_up/1/${enqID}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          });
          const data = await res.json();
          // console.log("Previous Followup Data.........", data);
          setPreFollowup(data);
        } catch (error) {
          console.error("Error fetching Previous Followup Data:", error);
        }
      }
    };
    getPreFollowup();
  }, [enqID]);

  // ####Enquiry single record
  const [openDetails, setOpenDeatils] = useState(false);
  const [evntId, setEvntId] = useState("");

  const handleOpenDetails = () => {
    setOpenDeatils(true);
  };
  const handleCloseDetails = () => {
    setOpenDeatils(false);
  };

  const eventIDRequest = (evt_id) => {
    setEvntId(evt_id);
  };

  // const filteredData = enq.filter((item) => {
  //     if (
  //         (selectedDate === '' || item.srv_id[0].start_date.includes(selectedDate)) &&
  //         (selectedService === '' || item.srv_id[0].srv_id.service_title.toLowerCase().includes(selectedService.toLowerCase())) &&
  //         (selectedCallerStatus === '' || selectedCallerStatus === 5 || item.patient_service_status === selectedCallerStatus)
  //     ) {
  //         return true;
  //     }
  //     return false;
  // });

  const filteredData = enq.filter((item) => {
    const hasValidService =
      item.srv_id && item.srv_id[0] && item.srv_id[0].srv_id;
    const hasValidStartDate = hasValidService && item.srv_id[0].start_date;

    const isDateMatch =
      selectedDate === "" ||
      (hasValidStartDate && item.srv_id[0].start_date.includes(selectedDate));
    const isServiceMatch =
      selectedService === "" ||
      (hasValidService &&
        item.srv_id[0].srv_id.service_title
          .toLowerCase()
          .includes(selectedService.toLowerCase()));
    const isCallerStatusMatch =
      selectedCallerStatus === "" ||
      selectedCallerStatus === 5 ||
      item.patient_service_status === selectedCallerStatus;

    return isDateMatch && isServiceMatch && isCallerStatusMatch;
  });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0"); // Get day with leading zero
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Get month with leading zero
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const getEnquiryStatusTooltip = (enquiryStatus) => {
    const title =
      enquiryStatus === "1"
        ? "Follow up reschedule"
        : enquiryStatus === "2"
          ? "Cancelled Enquiry"
          : enquiryStatus === "3"
            ? "Already tried to convert into service"
            : enquiryStatus === "4"
              ? "Follow up pending"
              : "";

    const iconColor =
      enquiryStatus === "1"
        ? "#1342BA"
        : enquiryStatus === "2"
          ? "#D61616"
          : enquiryStatus === "3"
            ? "#3D8A00"
            : enquiryStatus === "4"
              ? "#D61616"
              : "#000000";

    return (
      <Tooltip title={title} arrow>
        <IconButton>
          <CircleIcon style={{ color: iconColor, fontSize: "20px" }} />
        </IconButton>
      </Tooltip>
    );
  };

  const getCallerStatusTooltip = (callerStatus) => {
    const icon =
      callerStatus === 1 ? (
        <SmartphoneIcon style={{ color: "#EB8793" }} />
      ) : callerStatus === 2 ? (
        <LanguageIcon style={{ color: "#7AB7EE" }} />
      ) : callerStatus === 3 ? (
        <DirectionsWalkOutlinedIcon style={{ color: "#84CDB1" }} />
      ) : callerStatus === 4 ? (
        <CallOutlinedIcon style={{ color: "#8D9BED" }} />
      ) : callerStatus === 5 ? (
        <DoneAllOutlinedIcon style={{ color: "#8D9BED" }} />
      ) : (
        <SmartToyOutlinedIcon style={{ color: "#5b5bff" }} />
      );

    return <IconButton>{icon}</IconButton>;
  };

  return (
    <>
      <Navbar />
      {/* <Header /> */}
      <Box sx={{ flexGrow: 1, mt: 14, ml: 1, mr: 1, mb: 4 }}>
        <Stack
          direction={isSmallScreen ? "column" : "row"}
          spacing={1}
          alignItems={isSmallScreen ? "center" : "flex-start"}
          sx={{ pt: 1 }}
        >
          <Typography
            style={{
              fontSize: 16,
              fontWeight: 600,
              marginTop: "10px",
              marginLeft: "10px",
            }}
            color="text.secondary"
            gutterBottom
          >
            SERVICE ENQUIRIES
          </Typography>
          <Box
            component="form"
            sx={{
              marginLeft: "2rem",
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 300,
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <InputBase
              sx={{ ml: 1, mr: 1, flex: 1 }}
              placeholder="Select Date |  DD/MM/YYYY"
              inputProps={{ "aria-label": "select date" }}
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
            />
          </Box>

          <Box
            component="form"
            sx={{
              marginLeft: "2rem",
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 300,
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Service |"
              inputProps={{ "aria-label": "select service" }}
              value={selectedService}
              onChange={handleServiceChange}
            />
            <IconButton type="button" sx={{ p: "10px" }}>
              <SearchIcon style={{ color: "#7AB7EE" }} />
            </IconButton>
          </Box>

          <Box
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", md: 350 },
              height: "3rem",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderRadius: "16px",
              border: "1px solid #e5e7eb",
              boxShadow: "0 4px 16px rgba(0,0,0,0.07)",
              px: 0.7,
              gap: 0.4,
            }}
          >
            <Box
              sx={{
                px: 1,
                fontSize: "12px",
                fontWeight: 600,
                color: "#64748b",
                whiteSpace: "nowrap",
              }}
            >
              Filter
            </Box>

            {/* Mobile */}
            <IconButton
              onClick={() => setSelectedCallerStatus(1)}
              sx={{
                width: 38,
                height: 38,
                borderRadius: "11px",
                transition: "all .25s ease",
                backgroundColor:
                  selectedCallerStatus === 1 ? "#fff0f2" : "transparent",

                "&:hover": {
                  backgroundColor: "#fff0f2",
                  transform: "scale(1.12)",
                  boxShadow: "0 4px 12px rgba(235,135,147,.25)",
                },

                ...(selectedCallerStatus === 1 && {
                  animation: "pulsePink 1.5s infinite",
                }),

                "@keyframes pulsePink": {
                  "0%": {
                    boxShadow: "0 0 0 0 rgba(235,135,147,.4)",
                  },
                  "70%": {
                    boxShadow: "0 0 0 7px rgba(235,135,147,0)",
                  },
                  "100%": {
                    boxShadow: "0 0 0 0 rgba(235,135,147,0)",
                  },
                },
              }}
            >
              <SmartphoneIcon sx={{ color: "#EB8793", fontSize: 21 }} />
            </IconButton>

            {/* Website */}
            <IconButton
              onClick={() => setSelectedCallerStatus(2)}
              sx={{
                width: 38,
                height: 38,
                borderRadius: "11px",
                transition: "all .25s ease",
                backgroundColor:
                  selectedCallerStatus === 2 ? "#eef6ff" : "transparent",

                "&:hover": {
                  backgroundColor: "#eef6ff",
                  transform: "scale(1.12) rotate(5deg)",
                  boxShadow: "0 4px 12px rgba(122,183,238,.25)",
                },
              }}
            >
              <LanguageIcon sx={{ color: "#7AB7EE", fontSize: 22 }} />
            </IconButton>

            {/* Walk In */}
            <IconButton
              onClick={() => setSelectedCallerStatus(3)}
              sx={{
                width: 38,
                height: 38,
                borderRadius: "11px",
                transition: "all .25s ease",

                "&:hover": {
                  backgroundColor: "#eefaf5",
                  transform: "translateY(-4px) scale(1.08)",
                  boxShadow: "0 5px 12px rgba(132,205,177,.25)",
                },
              }}
            >
              <DirectionsWalkOutlinedIcon
                sx={{
                  color: "#84CDB1",
                  fontSize: 22,
                  transition: "transform .3s ease",
                }}
              />
            </IconButton>

            {/* Call */}
            <IconButton
              onClick={() => setSelectedCallerStatus(4)}
              sx={{
                width: 38,
                height: 38,
                borderRadius: "11px",
                transition: "all .25s ease",

                "&:hover": {
                  backgroundColor: "#f0f2ff",
                  transform: "scale(1.12)",
                  boxShadow: "0 4px 12px rgba(141,155,237,.3)",
                },

                "&:hover svg": {
                  animation: "ring 0.5s ease-in-out",
                },

                "@keyframes ring": {
                  "0%": { transform: "rotate(0deg)" },
                  "25%": { transform: "rotate(15deg)" },
                  "50%": { transform: "rotate(-15deg)" },
                  "75%": { transform: "rotate(10deg)" },
                  "100%": { transform: "rotate(0deg)" },
                },
              }}
            >
              <CallOutlinedIcon sx={{ color: "#8D9BED", fontSize: 22 }} />
            </IconButton>


            {/* AI */}
            <IconButton
              onClick={() => setSelectedCallerStatus(null)}
              sx={{
                width: 38,
                height: 38,
                borderRadius: "11px",
                transition: "all .25s ease",
                backgroundColor:
                  selectedCallerStatus === null ? "#f0f0ff" : "transparent",

                "&:hover": {
                  backgroundColor: "#f0f0ff",
                  transform: "scale(1.12)",
                  boxShadow: "0 4px 14px rgba(91,91,255,.25)",
                },

                "&:hover svg": {
                  animation: "robotFloat 1s ease-in-out infinite",
                },

                "@keyframes robotFloat": {
                  "0%, 100%": {
                    transform: "translateY(0px)",
                  },
                  "50%": {
                    transform: "translateY(-3px)",
                  },
                },
              }}
            >
              <SmartToyOutlinedIcon
                sx={{
                  color: "#5b5bff",
                  fontSize: 23,
                }}
              />
            </IconButton>

            {/* Completed */}
            <IconButton
              onClick={() => setSelectedCallerStatus(5)}
              sx={{
                width: 38,
                height: 38,
                borderRadius: "11px",
                transition: "all .25s ease",

                "&:hover": {
                  backgroundColor: "#fff7ed",
                  transform: "scale(1.12)",
                  boxShadow: "0 4px 12px rgba(246,144,13,.25)",
                },

                "&:hover svg": {
                  animation: "checkBounce .5s ease",
                },

                "@keyframes checkBounce": {
                  "0%": { transform: "scale(1)" },
                  "50%": { transform: "scale(1.3)" },
                  "100%": { transform: "scale(1)" },
                },
              }}
            >
              <DoneAllOutlinedIcon
                sx={{ color: "#F6900D", fontSize: 22 }}
              />
            </IconButton>
          </Box>

          {/* <Box
            component="form"
            sx={{
              marginLeft: "2rem",
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 310,
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="View Enquiry by |"
              inputProps={{ "aria-label": "view enquiry by" }}
            />
            <IconButton type="button" sx={{ p: "6px" }} aria-label="search">
              <SmartphoneIcon
                style={{ color: "#EB8793" }}
                onClick={() => setSelectedCallerStatus(1)}
              />
            </IconButton>
            <IconButton type="button" sx={{ p: "6px" }} aria-label="search">
              <LanguageIcon
                style={{ color: "#7AB7EE" }}
                onClick={() => setSelectedCallerStatus(2)}
              />
            </IconButton>
            <IconButton type="button" sx={{ p: "6px" }} aria-label="search">
              <DirectionsWalkOutlinedIcon
                style={{ color: "#84CDB1" }}
                onClick={() => setSelectedCallerStatus(3)}
              />
            </IconButton>
            <IconButton type="button" sx={{ p: "6px" }} aria-label="search">
              <CallOutlinedIcon
                style={{ color: "#8D9BED" }}
                onClick={() => setSelectedCallerStatus(4)}
              />
            </IconButton>
            <IconButton type="button" sx={{ p: "6px" }} aria-label="search">
              <DoneAllOutlinedIcon
                style={{ color: "#F6900D" }}
                onClick={() => setSelectedCallerStatus(5)}
              />
            </IconButton>
          </Box> */}
        </Stack>

        <TableContainer
          sx={{
            height:
              filteredData.length === 0 || filteredData.length < 5
                ? "60vh"
                : "default",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <EnquiryCard
                  style={{
                    color: "black",
                    borderRadius: "8px 10px 0 0",
                    display: "flex",
                    width: "100%",
                    height: "50px",
                    background: "rgb(186, 241, 248)",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 0.3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Source</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Event Code</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Patient Name</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Caller Mobile</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Service Name</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 0.8, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Diagnosis</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Start Date</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 0.8, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Zone</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 0.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Status</Typography>
                  </CardContent>
                  <CardContent style={{ flex: 1 }}>
                    <Typography variant="subtitle2">Action</Typography>
                  </CardContent>
                </EnquiryCard>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <CircularProgress size={32} />
                  </TableCell>
                </TableRow>
              ) : filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <Typography variant="body2">No Data Available</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={row.eve_id}>
                      <EnquiryCard
                        // style={{ display: "flex", width: "100%" }}
                        sx={{
                          background: "#f1f1f1",
                          borderLeft: "4px solid transparent",
                          transition: "all 0.3s ease-in-out",
                          cursor: "pointer",
                          "&:hover": {
                            borderLeft: "4px solid rgb(162, 217, 225)",
                            borderRight: "4px solid rgb(162, 217, 225)",
                            transform: "scale(1)",
                          },
                        }}
                      >
                        <CardContent style={{ flex: 0.5 }}>
                          <Typography variant="body2">
                            {index + 1 + page * rowsPerPage}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 0.3 }}>
                          <Typography variant="body2">
                            {getCallerStatusTooltip(row.patient_service_status)}
                          </Typography>
                        </CardContent>
                        <CardContent
                          style={{ flex: 1, cursor: "pointer" }}
                          onClick={() => {
                            eventIDRequest(row.eve_id);
                            handleOpenDetails();
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: "black",
                              "&:hover": {
                                color: "black",
                              },
                            }}
                          >
                            {row.event_code}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1.2 }}>
                          <Typography variant="body2">
                            {row.agg_sp_pt_id ? row.agg_sp_pt_id?.name : ""}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1 }}>
                          <Typography variant="body2">
                            {row.caller_no ? row.caller_no : "-"}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1.5 }}>
                          <Typography variant="body2">
                            {row.srv_id[0]
                              ? row.srv_id[0].srv_id.service_title
                              : "-"}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 0.8 }}>
                          <Typography variant="body2">
                            {row.Suffered_from?.length > 10
                              ? `${row.Suffered_from.slice(0, 6)}...`
                              : row.Suffered_from}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1 }}>
                          <Typography variant="body2">
                            {formatDate(
                              row.srv_id[0] ? row.srv_id[0].start_date : "-"
                            )}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 0.8 }}>
                          <Typography variant="body2">
                            {row.agg_sp_pt_id
                              ? row.agg_sp_pt_id.prof_zone_id?.Name
                              : "-"}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 0.5 }}>
                          <Typography variant="body2">
                            {getEnquiryStatusTooltip(
                              row.follow_up ? row.follow_up : ""
                            )}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1 }}>
                          <Button
                            variant="outlined"
                            onClick={() =>
                              handleOpen(findPreFollowupRecords(row.eve_id))
                            }
                            sx={{
                              textTransform: "capitalize",
                              borderRadius: 2,
                              width: "6rem",
                              mt: 1.2,
                              fontSize: "14px",
                              fontWeight: 500,
                              borderColor: "rgb(186, 241, 248)",
                              color: "#0097A7", // deeper teal text
                              "&:hover": {
                                borderColor: "rgb(186, 241, 248)",
                                backgroundColor: "rgb(186, 241, 248)",
                                color: "#000",
                              },
                            }}
                          >
                            Followup
                          </Button>

                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box
                              sx={{
                                ...style,
                                width: 400,
                                borderRadius: "10px",
                                bgcolor: "#fff",
                                boxShadow: 24,
                                p: 0,
                              }}
                            >
                              {/* AppBar Header */}
                              <AppBar
                                position="static"
                                sx={{
                                  background: "rgb(186, 241, 248)",
                                  height: "3.2rem",
                                  borderRadius: "10px 10px 0 0",
                                  display: "flex",
                                  flexDirection: "row", // Ensures row layout
                                  justifyContent: "space-between", // Push items to sides
                                  alignItems: "center",
                                  px: 2,
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    color: "#000",
                                  }}
                                >
                                  Follow Up Enquiry
                                </Typography>
                                <IconButton
                                  onClick={handleClose}
                                  sx={{ color: "#000", ml: "auto" }}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </AppBar>

                              {/* Followup content */}
                              <Box sx={{ p: 2 }}>
                                <Followup
                                  sendData={preFollowup}
                                  enqData={enqID}
                                  onClose={handleClose}
                                  flag={flag}
                                />
                              </Box>
                            </Box>
                          </Modal>
                        </CardContent>
                      </EnquiryCard>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Modal open={openDetails} onClose={handleCloseDetails}>
          <Box
            sx={{
              width: 600,
              maxHeight: "80vh",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 3,
              overflowY: "auto",
              mt: 8,
              mx: "auto",
            }}
          >
            <EnqDetails
              eveID={evntId}
              open={openDetails}
              onClose={handleCloseDetails}
            />
          </Box>
        </Modal>

        <TablePagination
          sx={{ overflowY: 'hidden' }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      <Footer />
    </>
  );
};

export default Enquiries;
